import React, { useState, useCallback } from "react";
import {
  Routes,
  Route,
  BrowserRouter as Router,
  useNavigate,
} from "react-router-dom";
import "./App.css";
import Header from "./Components/Header";
import Footer from "./Components/Footer";
import Intro from "./Components/ContentPages/Intro.tsx";
import ScrollToTop from "./Components/ScrollToTop";
import { AppProvider } from "./contexts/AppContext";
import useBackButtonPopup from "./useBackButtonPopup.js";
import BrowserBack from "./Components/Popups/BrowserBack/index.js";
import IdleTimeout from "./contexts/IdleTimeout"; // ✅ fixed import
import { setNavigator } from "./Services/navigator";
import EnvBanner from "./Components/EnvBanner.jsx";

function NavigatorInit() {
  const nav = useNavigate();
  setNavigator(nav);
  return null;
}

function App() {
  const [showBackPopup, setShowBackPopup] = useState(false);

  // const handleBackAttempt = useCallback(() => {
  //   setShowBackPopup(true);
  // }, []);

  // useBackButtonPopup(handleBackAttempt);

  return (
    <AppProvider>
      {showBackPopup && <BrowserBack onClose={() => setShowBackPopup(false)} />}

      <Router>
        <NavigatorInit />
        <IdleTimeout timeoutDuration={10} />
        <ScrollToTop />
        <EnvBanner />
        <div
          id="root"
          style={{
            display: "flex",
            flexDirection: "column",
            minHeight: "100vh",
          }}
        >
          <Header />
          <main className="main-content">
            <Routes>
              <Route path="/*" element={<Intro />} />
              {/* Add other routes as needed */}
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </AppProvider>
  );
}

export default App;
